<template>
    <div>
        <!-- <section style="margin-top:-7px" class="hero is-small is-primary" v-if="!$route.path.includes('share')">
            <div class="hero-body">
                <div style="text-align:center; color:white !important" class="title is-3 is-info" >Share and discover bicycle travel stories.</div>
            </div>
        </section> -->
        <div class="banner-image">
          
            <!-- <section style="margin-top:-7px" class="hero is-small" v-if="!$route.path.includes('share')">
                <div class="hero-body">
                        <div  class="is-primary">
                            <div><h2 class="has-text-primary banner-text" style="font-weight: normal; padding-top:10px; max-width: 810px; margin-left: auto; margin-right: auto">BikeSleepBike is a <strong class="has-text-primary">growing directory</strong> of independent <strong class="has-text-primary">bike travel blogs</strong>
                            organized by <strong class="has-text-primary">country, route, style</strong>, and more.</h2></div>
                    
                    </div>
                </div>
            </section> -->
            </div>
            
    </div>
</template>

<script>
export default {
  name: 'MarketingBanner',
  data () {
    return {
        // totals: {}
    }
  },
  mounted() {
    this.$getTotals();
    //   var that = this;
    //   this.$db.collection("counts").doc("totals").get()
    //     .then(function(doc) {
            
    //         if (doc.exists){
    //             console.log(doc.data());
    //             that.totals = doc.data();
    //         }
        
    //     }).catch(function(error) {
    //         console.error("Error fetching totals: ", error);
    //     });

  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
     .info-col {
    padding:20px 70px;
    font-size:17px;
    
  }
  .banner-image .hero-body {
      background-color: transparent;    
  }
  .banner-image h2,
  .banner-image h2 strong {
      color: white !important;

  }
  .info-col .container {
    
  }
  .info-col p {
    font-size:19px;
    margin-top:20px;
    line-height:23px;
    
  }
  .banner-text {
    font-size:25px; 
  }
  @media screen and (max-width: 768px) {
    .info-col {
      padding: 20px 30px;
    }
    .banner-text {
        font-size:20px;
    }
}
@media screen and (min-width: 1024px) {
    .info-col .container {
      max-width:300px;
    }
}

 .banner-image {
    background-size:contain !important; 
    /* background-image: url(https://bikesleepbike.com/bsb_banner.jpg ); */
    background-repeat: no-repeat;
    background-size: 100%
  }
  @media screen and (max-width: 568px) {
    .banner-image {
      background-image: url(https://bikesleepbike.com/BikeSleepBike_banner_mobile_dark.png) !important;
      width:100vw;
      height:75vw;
      background-size: contain;
    }
  }
  @media screen and (min-width: 569px) {
    .banner-image {
      width:100vw;
      height:21vw;
      /* position: absolute;
      top: 0;
      left: 0; */
      /* background-position: center top;
      background-size: 100% auto;*/
      background-size:contain; 
      background-image: url(https://bikesleepbike.com/BikeSleepBike_banner_wide_dark.jpg);
      /* background-image: url(https://bikesleepbike.com/BikeSleepBike_wide_banner.jpg); */
     
      /* background-repeat: no-repeat; */
      /* background-size: 100% */
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MarketingBanner.vue